import * as actions from './action';

const init = {
  activeStep: 1,
  countryCode: null,
  profiles: [],
  selectedProfiles: [],
  onboardingDone: false,
  connectedAdsAccount: false,
  connectedSPAccount: false,
  amazonVendorAccount: false,
};

export default (state = init, action) => {
  let newState = { ...state };

  switch (action.type) {
    case actions.ONBOARDING_LAUNCH_SET_STEP:
      newState.activeStep = action.payload;
      break;
    case actions.ONBOARDING_SET_COUNTRY_CODE:
      newState.country = action.payload;
      break;
    case actions.ONBOARDING_SET_CONFIG:
      newState = { ...state, ...action.data };
      break;
    case actions.ONBOARDING_SET_CONFIG_DATA:
      newState[action.key] = action.value;
      break;
    case actions.ONBOARDING_CLEAR_CONFIG_DATA:
      newState = { ...init };
      break;
    default:
  }
  return newState;
};
